import { Type } from 'typebox';
import { Format } from 'typebox/format';
export const TypeBoxShortIsoCalendarDateFormat = 'short-iso-calendar-date';
const shortIsoCalendarDatePattern = /^\d{4}-\d{2}-\d{2}$/;
export function isShortIsoCalendarDateString(value) {
    if (!shortIsoCalendarDatePattern.test(value)) {
        return false;
    }
    const [yearPart, monthPart, dayPart] = value.split('-');
    const year = Number(yearPart);
    const month = Number(monthPart);
    const day = Number(dayPart);
    const candidate = new Date(Date.UTC(year, month - 1, day));
    return (candidate.getUTCFullYear() === year &&
        candidate.getUTCMonth() === month - 1 &&
        candidate.getUTCDate() === day);
}
export function registerTypeBoxShortIsoCalendarDateFormat() {
    if (!Format.Has(TypeBoxShortIsoCalendarDateFormat)) {
        Format.Set(TypeBoxShortIsoCalendarDateFormat, (value) => isShortIsoCalendarDateString(value));
    }
}
export const ShortIsoCalendarDateCodec = Type.Codec(Type.String())
    .Decode((value) => {
    return typeof value === 'string' && isShortIsoCalendarDateString(value) ? value : undefined;
})
    .Encode((value) => {
    if (value === undefined) {
        throw new Error('Cannot encode an unavailable short ISO calendar date');
    }
    return value;
});
